import { apiFormDataRequest, apiRequest } from './apiClient';

export async function uploadStudentAnswerFile(slug, entityId, questionId, file) {
  const formData = new FormData();
  formData.append('file', file);

  const response = await apiFormDataRequest(
    `/student/${slug}/${entityId}/answers/${questionId}/file`,
    formData
  );

  return response.data || null;
}

export async function deleteStudentAnswerFile(slug, entityId, questionId) {
  const response = await apiRequest(
    `/student/${slug}/${entityId}/answers/${questionId}/file`,
    { method: 'DELETE' }
  );

  return response.data || null;
}
